import React, { useState, useEffect } from "react";
import axios from "axios";
import APIEndPoints from "../../../middleware/APIEndPoints";

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const contatUsListUrl = APIEndPoints.contactUSList.url;
  const contactUsDeletetUrl = APIEndPoints.contactUsDelete.url;

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get(contatUsListUrl, {
          params: { page },
        });
        setContacts(response.data.contacts);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error("Error fetching contacts:", error);
      }
    };
    fetchContacts();
  }, [page]);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${contactUsDeletetUrl}/${id}`);
      setContacts(contacts.filter((contact) => contact._id !== id));
    } catch (error) {
      console.error("Error deleting contact:", error);
    }
  };

  return (
    <div className="bg-[#1d0c39]  min-h-screen p-8 text-white">
      <h2 className="text-2xl mb-4">Contact List</h2>
      <ul>
        {contacts.map((contact) => (
          <li key={contact._id} className="border-b p-4">
            <p>
              <strong>Name:</strong> {contact.name}
            </p>
            <p>
              <strong>Email:</strong> {contact.email}
            </p>
            <p>
              <strong>Message:</strong> {contact.message}
            </p>
            <p>
              <strong>Created At:</strong>{" "}
              {new Date(contact.createdAt).toLocaleDateString()}
            </p>
            <button
              onClick={() => handleDelete(contact._id)}
              className="text-red-500"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
      <div className="flex justify-between mt-4">
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="btn"
        >
          Previous
        </button>
        <span>
          Page {page} of {totalPages}
        </span>
        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          className="btn"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ContactList;
